export default __webpack_public_path__ + "static/media/Aura-Egg__78.2ef775a3.png";